//import Facebook from '_c/icon/Facebook';
//import Twitter from '_c/icon/Twitter';
//import Pinterest from '_c/icon/Pinterest';
//import Linkedin from '_c/icon/Linkedin';
//import Instagram from '_c/icon/Instagram';
//import Youtube from '_c/icon/Youtube';
import Vk from '_c/icon/Vk';
import Google from '_c/icon/Google';
import {API_URL} from '@/misc/constants';

const authUrl = `${API_URL}/auth`;
export default [
  {
    Icon: Google,
    link: `${authUrl}/google`,
    label: 'google',
  },
  {
    Icon: Vk,
    link: `${authUrl}/vk`,
    label: 'vk',
  },
  //{
  //  Icon: Facebook,
  //  link: '/',
  //  label: 'facebook',
  //},
  //{
  //  Icon: Twitter,
  //  link: '/',
  //  label: 'twitter',
  //},
  //{
  //  Icon: Pinterest,
  //  link: '/',
  //  label: 'pinterest',
  //},
  //{
  //  Icon: Linkedin,
  //  link: '/',
  //  label: 'linkedin',
  //},
  //{
  //  Icon: Instagram,
  //  link: '/',
  //  label: 'instagram',
  //},
  //{
  //  Icon: Youtube,
  //  link: '/',
  //  label: 'youtube',
  //},
];
